import { MouseEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetHeroIcon from "../../../utils/getHeroIcon";

function BackButton({ excludedPaths }: { excludedPaths: string[] }) {
  const navigate = useNavigate();
  const location = useLocation();
  const navigateBack = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate(-1);
  };
  if (excludedPaths.includes(location.pathname)) {
    return "";
  }
  return (
    <button
      className="breadcrumb-item hover:bg-primary flex items-center bg-gray-500 text-gray-100 dark:bg-profile-bkg p-px px-2 rounded-full gap-1 cursor-pointer text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 border-none"
      onClick={navigateBack}
      aria-label="Go Back"
    >
      <GetHeroIcon
        name={"ChevronLeftIcon"}
        variant="solid"
        className="h-4 text-gray-200"
      />
      <span className="text-sm">Back</span>
    </button>
  );
}

export default BackButton;
